// extracted by mini-css-extract-plugin
export default {"Screensaver":"Screensaver_Screensaver__DYumF","Content":"Screensaver_Content__jCAQe","Logo":"Screensaver_Logo__zXFwe"};